import React, { Component } from 'react'
import withRouter from '../lib/withRouter';
import { connect } from 'react-redux';
import Authentication from '../../session'
import Service from '../services'
import { BasicLazyParams } from '../../utile';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getBranchesLatest } from '../../store/actions';
import BranchToClassDDRow from '../BaseDropdownComponents/BranchToClassDDRow';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import LoadingComponent from '../loadingComponent';
import { baseUrlAdmin } from '../../store/apiConstants';
import { Chart } from 'primereact/chart';
import { Button } from 'primereact/button';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { Toast } from 'primereact/toast';

const months = [
    { value: "January", label: 'January' },
    { value: "February", label: 'February' },
    { value: "March", label: 'March' },
    { value: "April", label: 'April' },
    { value: "May", label: 'May' },
    { value: "June", label: 'June' },
    { value: "July", label: 'July' },
    { value: "August", label: 'August' },
    { value: "September", label: 'September' },
    { value: "October", label: 'October' },
    { value: "November", label: 'November' },
    { value: "December", label: 'December' }
]
const formatOptions = [
    { value: 1, label: "Bar Chart" },
    { value: 2, label: "Pie Chart" },
    { value: 3, label: "Line Chart" }
]
class MultiStageConversionGraph extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filteredUsers: [],
            lazyParams: BasicLazyParams,
            totalRecords: 0,
            globalFilter: null,
            selectedMonths: [],
            selectedFormat: null,
            loading: false,
            fullReportData: [],
            filteredReportData: [],
            reportData: [],
            selectedBranch: [],
            selectedBoard: [],
            selectedGrade: [],
            isLoading: false,
        };
        this.service = new Service();
    }

    async componentDidMount() {
        this.props.getBranchesLatest(true);
        await this.fetchReportData();
    }

    onPage = (event) => {
        this.setState((prevState) => ({
            lazyParams: {
                ...prevState.lazyParams,
                ...event
            }
        }), this.updatePaginatedData);
    };

    updatePaginatedData = () => {
        const { lazyParams, filteredReportData } = this.state;
        const startIndex = lazyParams.first;
        const endIndex = startIndex + lazyParams.rows;
        const paginatedData = filteredReportData.slice(startIndex, endIndex);
        this.setState({ reportData: paginatedData });
    };

    filterReportData = () => {
        const { fullReportData, selectedBranch, selectedBoard, selectedGrade, selectedMonths } = this.state;
        let filteredData = [...fullReportData];


        if (selectedMonths?.length > 0) {
            filteredData = filteredData.filter(item => selectedMonths.includes(item.month));
        }


        let branch = selectedBranch?.map(item => item).flat();
        let board = selectedBoard?.map(item => item).flat();
        let grade = selectedGrade?.map(item => item).flat();

        if (branch?.length > 0) {
            filteredData = filteredData.filter(item => branch.includes(item.branchId));
        }
        if (board?.length > 0) {
            filteredData = filteredData.filter(item => board.includes(item.boardId));
        }
        if (grade?.length > 0) {
            filteredData = filteredData.filter(item => grade.includes(item.gradeId));
        }

        this.setState({
            filteredReportData: filteredData,
            totalRecords: filteredData.length
        }, this.updatePaginatedData);
    };

    fetchReportData = async () => {
        this.setState({ isLoading: true });
        try {
            const response = await this.service.post(`${baseUrlAdmin}/admissionReports/`, {
                academicYear: localStorage.getItem('userAcademicYear'),
                months: this.state.selectedMonths,
                branchId: this.state.selectedBranch,
                boardId: this.state.selectedBoard,
                gradeId: this.state.selectedGrade
            }, true);

            if (response?.res?.status) {
                this.setState({
                    fullReportData: response?.res?.data,
                    filteredReportData: response?.res?.data,
                    totalRecords: response?.res?.data.length
                }, this.updatePaginatedData);
            }
        } catch (error) {
            console.error('Error fetching report data:', error);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    setDropdownValues = (values) => {
        this.setState((prevState) => ({
            selectedBranch: values.branchId,
            selectedBoard: values.boardId,
            selectedGrade: values.classId
        }), this.filterReportData)
    };

    onChangeMonths = (e) => {
        this.setState({
            selectedMonths: e.value
        }, this.filterReportData);
    };

    onChangeFormat = (e) => {
        this.setState({
            selectedFormat: e.value
        });
    }

    exportToExcel = () => {
        const { filteredReportData } = this.state;

        // Format data for export
        const exportData = filteredReportData.map(item => ({
            'Branch': item.branchName,
            'Board': item.boardName,
            'Grade': item.gradeName,
            'Month': item.month,
            'Enquiry': item.enquiries,
            'Application': item.applications,
            'Exam': item.exams,
            'Registration': item.registrations,
            'Enrollment': item.enrollments
        }));

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Conversion Report");

        // Generate and download file
        XLSX.writeFile(workbook, `Multi_Stage_Conversion_Report_${moment().format('DD-MM-YYYY')}.xlsx`);
    };

    handleViewAnalysis = () => {
        this.setState({
            selectedFormat: 1,
            selectedRowData: null,
            showGraphDialog: true
        });
    };

    handleViewReport = (rowData) => {
        if (!this.state.selectedFormat) {
            this.toast.current?.show({
                severity: 'warn',
                summary: 'Format Required',
                detail: 'Please select a format before viewing the report',
                life: 3000
            });
            return;
        }
        this.setState({
            selectedRowData: rowData,
            showGraphDialog: true
        });
    };

    hideGraphDialog = () => {
        this.setState({
            showGraphDialog: false,
            selectedRowData: null
        });
    };

    actionBodyTemplate = (rowData) => {
        return (
            <Button
                label="View Report"
                icon="pi pi-chart-bar"
                className="p-button-sm"
                onClick={() => this.handleViewReport(rowData)}
                style={{
                    height: "32px",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    fontSize: "14px"
                }}
            />
        );
    };

    getChartData = () => {
        const { reportData, selectedRowData } = this.state;

        // If viewing a specific row's data, use that; otherwise aggregate all data
        const dataToProcess = selectedRowData ? [selectedRowData] : reportData;
        const totals = dataToProcess.reduce((acc, curr) => {
            acc.enquiries += curr.enquiries || 0;
            acc.applications += curr.applications || 0;
            acc.exams += curr.exams || 0;
            acc.registrations += curr.registrations || 0;
            acc.enrollments += curr.enrollments || 0;
            return acc;
        }, {
            enquiries: 0,
            applications: 0,
            exams: 0,
            registrations: 0,
            enrollments: 0
        });

        const labels = ['Enquiries', 'Applications', 'Exams', 'Registrations', 'Enrollments'];
        const data = [
            totals.enquiries,
            totals.applications,
            totals.exams,
            totals.registrations,
            totals.enrollments
        ];

        const chartColors = ['#0B8FD9', '#819AF2', '#C6D2FD', '#962DFF', '#D3ADF9'];

        const datasets = [{
            data: data,
            backgroundColor: this.state.selectedFormat === 3 ? '#42A5F5' : chartColors,
            borderColor: this.state.selectedFormat === 3 ? '#42A5F5' : chartColors,
            tension: 0.4,
            names: ['Enquiries', 'Applications', 'Exams', 'Registrations', 'Enrollments'],
            borderRadius: {
                topLeft: 8,
                topRight: 8,
                bottomLeft: 0,
                bottomRight: 0
            }
        }];

        return { labels, datasets };
    };

    getChartOptions = () => {
        const options = {
            maintainAspectRatio: false,
            aspectRatio: 1.2,
            plugins: {
                legend: {
                    position: this.state.selectedFormat === 2 ? 'right' : 'bottom',
                    display: this.state.selectedFormat === 2,
                    labels: {
                        usePointStyle: this.state.selectedFormat === 2,
                        pointStyle: 'circle',
                        boxWidth: 6,
                        boxHeight: 6,
                        color: '#000000',
                        font: {
                            family: 'InterRegular',
                            size: 12
                        }
                    }
                },
                title: {
                    display: true,
                    text: 'Multi-Stage Conversion Graphs',
                    font: { size: 16, weight: 500, family: 'InterBold' },
                    color: '#000000',
                },
                tooltip: {
                    callbacks: {
                        label: function (context) {
                            if (context.raw !== undefined && context.raw !== null && context.raw !== 0) {
                                const value = context.raw;
                                const label = context.dataset.names[context.dataIndex];
                                return `${label}: ${value}`;
                            }
                            return null;
                        }
                    },
                    enabled: true,
                    mode: this.state.selectedFormat === 2 ? 'nearest' : 'index',
                    intersect: this.state.selectedFormat === 2,
                    position: 'nearest',
                }
            },
            interaction: {
                mode: this.state.selectedFormat === 2 ? 'nearest' : 'index',
                intersect: this.state.selectedFormat === 2,
                axis: this.state.selectedFormat === 2 ? 'xy' : 'x'
            },
            scales: {
                y: {
                    display: this.state.selectedFormat !== 2,
                    beginAtZero: true,
                    ticks: {
                        stepSize: 1,
                        callback: function (value) {
                            return Math.round(value);
                        }
                    },
                    grid: {
                        color: "#82889880",
                        borderDash: [5, 5],
                        drawBorder: true,
                        drawOnChartArea: true,
                        lineWidth: 0.5
                    },
                    title: {
                        display: false
                    }
                },
                x: {
                    display: this.state.selectedFormat !== 2,
                    grid: {
                        display: false
                    },
                    title: {
                        display: false
                    }
                }
            },
            barPercentage: 0.2,
            categoryPercentage: 0.7,
            elements: {
                bar: {
                    borderRadius: {
                        topLeft: 5,
                        topRight: 5,
                        bottomLeft: 0,
                        bottomRight: 0
                    },
                    borderSkipped: false
                }
            },
            cutout: this.state.selectedFormat === 2 ? '50%' : undefined
        };

        return options;
    };

    renderChart = () => {
        const data = this.getChartData();
        const options = this.getChartOptions();

        switch (this.state.selectedFormat) {
            case 1:
                return <Chart type="bar" data={data} options={options} style={{ height: '500px', width: "734px" }} />;
            case 2:
                return <Chart type="pie" data={data} options={options} style={{ height: '500px', width: "734px" }} />;
            case 3:
                return <Chart type="line" data={data} options={options} style={{ height: '500px', width: "734px" }} />;
            default:
                return null;
        }
    };

    render() {
        const containerStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: window.innerWidth > 1090 ? "50px 0px 0px 95px" : "50px 0px 0px 15px",
            overflow: 'auto',
            transition: 'padding 0.3s',
            paddingBottom: '30px',
        };
        return (
            <>
                <div style={containerStyle} className=' m-2'>
                    <Toast ref={this.toast} position="bottom-right" />
                    <div className="card filters-card mt-1 pt-0">
                        <BranchToClassDDRow
                            setValues={this.setDropdownValues}
                            showTooltip={false}
                            tooltip={null}
                            tooltipOptions={{ disabled: true }}
                        />
                        <div className='flex '>
                            <div className="col-4 my-2">
                                <ClassetMultiSelect
                                    required={true}
                                    label={'Months'}
                                    placeholder={'Select Month'}
                                    options={months}
                                    value={this.state.selectedMonths}
                                    onChange={this.onChangeMonths}
                                    optionLabel="label"
                                    optionValue="value"
                                    multiple={true}
                                />
                            </div>
                            <div className="col-4 my-2">
                                <ClassetDropdown
                                    required={true}
                                    label={'Format'}
                                    placeholder={'Select Format'}
                                    options={formatOptions}
                                    value={this.state.selectedFormat}
                                    onChange={this.onChangeFormat}
                                    optionLabel="label"
                                    optionValue="value"
                                />
                            </div>
                            <div className="col-3 mt-5 flex justify-content-end align-items-center gap-3 ms-auto" style={{ maxWidth: 'fit-content' }}>
                                <Button
                                    label="Download Report"
                                    onClick={this.exportToExcel}
                                    style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#F4F5F6", color: "#000" }}
                                />
                                <Button
                                    label="View Analysis"
                                    icon="pi pi-chart-bar"
                                    onClick={this.handleViewAnalysis}
                                    style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", backgroundColor: "#2196F3", color: "#fff" }}
                                />
                            </div>

                        </div>
                    </div>
                    <div className="datatable-report-demo mx-2">
                        {this.state.selectedFormat ? (
                            <div className=" flex align-items-center justify-content-center"
                                style={{
                                    minHeight: '600px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto',
                                    maxWidth: '1000px'
                                }}>
                                {this.renderChart()}
                            </div>
                        ) : (
                            <DataTable
                                value={this.state.reportData}
                                responsiveLayout="scroll"
                                dataKey="id"
                                paginator
                                lazy
                                onPage={this.onPage}
                                resizableColumns
                                first={this.state.lazyParams.first}
                                last={this.state.totalRecords}
                                rows={this.state.lazyParams.rows}
                                totalRecords={this.state.totalRecords}
                                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                globalFilter={this.state.globalFilter}
                                rowClassName={() => 'table-row-style'}
                            >
                                <Column field="branchName" header="Branch" />
                                <Column field="boardName" header="Board" />
                                <Column field="gradeName" header="Grade" />
                                <Column field="month" header="Month" />
                                <Column field="enquiries" header="Enquiry" />
                                <Column field="applications" header="Application" />
                                <Column field="exams" header="Exam" />
                                <Column field="registrations" header="Registration" />
                                <Column field="enrollments" header="Enrollment" />
                            </DataTable>
                        )}
                    </div>
                    {this.state.isLoading && <LoadingComponent />}
                </div>
            </>
        )
    }
}

const mapStatesToProps = (state) => ({
    isLoading: state.boardsData.loading,
    isBranchLoading: state.branchDataLatest.isLoading,
    branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data?.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        [],
    _id: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data._idF
});
export default connect(mapStatesToProps, { getBranchesLatest })(Authentication(withRouter(MultiStageConversionGraph)));